import {AgentSessionId, AgentSessionMessage, AgentSessionMessageFilter, CreateAgentSessionUserMessage} from "../Types";
import {CURRENT_REGION} from "../utils/region";
import jsonApi from "./jsonApi";

export async function listMessages(agentSessionId: AgentSessionId, args: AgentSessionMessageFilter) {
  return await jsonApi.get<AgentSessionMessage[]>(
    `/region/${CURRENT_REGION}/api/agent_sessions/${agentSessionId}/messages?${jsonApi.encodeQuery(args)}`,
  );
}

export async function sendMessage(agentSessionId: AgentSessionId, message: CreateAgentSessionUserMessage) {
  await jsonApi.post<string>(`/region/${CURRENT_REGION}/api/agent_sessions/${agentSessionId}/messages`, message);
}
